import encodeObjForm from './encodeObjForm.json'

// const colorScheme = [
//     'rgba(85, 239, 196,1.0)',
//     'rgba(0, 184, 148,1.0)',
//     'rgba(255, 234, 167,1.0)',
//     'rgba(253, 203, 110,1.0)',
//     'rgba(129, 236, 236,1.0)',
//     'rgba(0, 206, 201,1.0)',
//     'rgba(250, 177, 160,1.0)',
//     'rgba(225, 112, 85,1.0)',
//     'rgba(116, 185, 255,1.0)',
//     'rgba(9, 132, 227,1.0)',
//     'rgba(255, 118, 117,1.0)',
//     'rgba(214, 48, 49,1.0)',
//     'rgba(162, 155, 254,1.0)',
//     'rgba(108, 92, 231,1.0)',
//     'rgba(253, 121, 168,1.0)',
//     'rgba(232, 67, 147,1.0)',
// ].sort( () => .5 - Math.random() )
// console.log(JSON.stringify(colorScheme))

const colorScheme = [
	"rgba(250, 177, 160,1.0)",
	"rgba(255, 234, 167,1.0)",
	"rgba(85, 239, 196,1.0)",
	"rgba(162, 155, 254,1.0)",
	"rgba(108, 92, 231,1.0)",
	"rgba(129, 236, 236,1.0)",
	"rgba(253, 203, 110,1.0)",
	"rgba(0, 184, 148,1.0)",
	"rgba(232, 67, 147,1.0)",
	"rgba(253, 121, 168,1.0)",
	"rgba(0, 206, 201,1.0)",
	"rgba(255, 118, 117,1.0)",
	"rgba(225, 112, 85,1.0)",
	"rgba(214, 48, 49,1.0)",
	"rgba(116, 185, 255,1.0)",
	"rgba(9, 132, 227,1.0)"
]

function doubleSort(arr1, arr2) {

	let list = []
	for (var j = 0; j < arr1.length; j++)
		list.push({ 'arr1': arr1[j], 'arr2': arr2[j] });

	list.sort(function (a, b) {
		return ((a.arr1 > b.arr1) ? -1 : ((a.arr1 == b.arr1) ? 0 : 1));
		//Sort could be modified to, for example, sort on the age
		// if the name is the same.
	});

	//3) separate them back out:
	for (var k = 0; k < list.length; k++) {
		arr1[k] = list[k].arr1;
		arr2[k] = list[k].arr2;
	}
	return [
		arr1,
		arr2
	]
}

function prepareBarData(data) {
	if (!data) { return {} }
	let chartData = {}
	chartData.labels = []
	chartData.datasets = [{
		backgroundColor: "#f87979",
		data: []
	}]
	data.forEach((item) => {
		chartData.labels.push(item.comercial.name)
		chartData.datasets[0].data.push(item.ventas)
	})
	let sorted = doubleSort(chartData.datasets[0].data, chartData.labels)
	chartData.datasets[0].data = sorted[0]
	chartData.labels = sorted[1]

	return chartData
}

// function preparePieData(data, name){
//     if(!data){
//         return {}
//     }
//     // console.log(data)
//     let chartData = {}
//     chartData.labels = []
//     chartData.datasets = [{
//         data: [],
//         backgroundColor: colorScheme
//     }]
//     data.forEach((item) => {
//         chartData.labels.push(
//             Object.keys(encodeObjForm[name]).find((key) => encodeObjForm[name][key]==item.type)
//         )
//         chartData.datasets[0].data.push(item.count)
//     })
//     let sorted = doubleSort(chartData.datasets[0].data, chartData.labels)
//     chartData.datasets[0].data = sorted[0]
//     chartData.labels = sorted[1]

//     return chartData
// }

function preparePieData(chartData, label) {

	// Random bright tones generator
	let getRandomColor = () => {
		let R = Math.floor((Math.random() * 127) + 127);
		let G = Math.floor((Math.random() * 127) + 127);
		let B = Math.floor((Math.random() * 127) + 127);

		let rgb = (R << 16) + (G << 8) + (B << 0);
		return `#${rgb.toString(16)}`;
	}

	// Delete all non numeric values
	let copy = {}
	for (let element in chartData) {
		if (!isNaN(chartData[element]))
			copy[element] = chartData[element]
	}

	let colors = []
	for (var i = 0; i < Object.keys(copy).length; i++) {
		colors.push(getRandomColor())
	}

	// Sort object by values
	var sortable = [];
	for (var item in copy) {
		sortable.push([item, copy[item]]);
	}

	sortable.sort(function (a, b) {
		return a[1] - b[1];
	});

	copy = {}
	sortable.forEach(item => {
		copy[item[0]] = item[1]
	})

	// Set labelspreparePieData
	let labels = []
	for (let label in Object.keys(copy)) {
		labels.push(Object.keys(copy)[label].toUpperCase().replace('_', ' '))
	}

	return {
		labels: labels,
		datasets: [
			{
				label: label,
				data: Object.values(copy),
				backgroundColor: colors,
				hoverOffset: 4,
			},
		],
	};
}

function prepareTimeData(data) {
	if (!data) { return {} }

	let chartData = {}
	// chartData.labels = [
	//     "Enero",
	//     "Febrero",
	//     "Marzo",
	//     "Abril",
	//     "Mayo",
	//     "Junio",
	//     "Julio",
	//     "Agosto",
	//     "Septiembre",
	//     "Octubre",
	//     "Noviembre",
	//     "Diciembre"
	// ]
	chartData.datasets = [{
		data: [],
		backgroundColor: 'rgba(46, 153, 199, 0.5)'
	}]
	data.forEach((item) => {
		chartData.datasets[0].data.push({
			x: new Date(item.date),
			y: item.num
		})
	})
	// let sorted = doubleSort(chartData.datasets[0].data, chartData.labels)
	// chartData.datasets[0].data = sorted[0]
	// chartData.labels = sorted[1]

	// console.log(chartData)
	return chartData
}

export {
	prepareBarData,
	preparePieData,
	prepareTimeData
}
